// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"138149f0","703":"4bb8da1e"}[chunkId] + ".chunk.js";
};